import { Injectable, inject, signal } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import {
  LocationGQL,
  LocationQuery,
  LocationsByCursorGQL,
  LocationsByCursorQuery,
  LocationsByCursorOrderByInput,
  WarrantyStatus
} from '@generated/sammathnaur.graphql'
import { firstValueFrom } from 'rxjs'
import type { Apollo } from 'apollo-angular'

@Injectable({
  providedIn: 'root',
})
export class LocationsService {
  public readonly filterForm = new FormGroup({
    locationGroupId_in: new FormControl([] as string[]),
    archived: new FormControl(false as 'all' | false | true),
    sectorEnvironmentEquipmentNameOrNumberContains: new FormControl(''),
    warrantyStartDateLte: new FormControl(''),
    warrantyEndDateGte: new FormControl(''),
    warrantyStatusIn: new FormControl([] as string[])
  })

  public orderBy = signal<LocationsByCursorOrderByInput>(LocationsByCursorOrderByInput.CreatedAtDesc)
  public take = signal<number>(25)
  public after = signal<string | null>(null)

  public readonly locationsByCursorGQL = inject(LocationsByCursorGQL)
  public readonly locationGQL = inject(LocationGQL)

  public async searchPage(): Promise<Apollo.QueryResult<LocationsByCursorQuery>> {
    const { sectorEnvironmentEquipmentNameOrNumberContains, locationGroupId_in, warrantyEndDateGte, warrantyStartDateLte, warrantyStatusIn, archived } = this.filterForm.value

    const observable$ = this.locationsByCursorGQL.fetch({
      variables: {
        where: {
          locationGroupId_in,
          sectorEnvironmentEquipmentNameOrNumberContains,
          warrantyStartDateLte,
          warrantyEndDateGte,
          warrantyStatusIn: warrantyStatusIn as WarrantyStatus[],
          archived: archived === 'all' ? undefined : archived,
        },
        take: this.take(),
        after: this.after(),
        orderBy: this.orderBy(),
      },
    })

    return firstValueFrom(observable$)
  }

  public async searchOne(id: string): Promise<Apollo.QueryResult<LocationQuery>> {
    const observable$ = this.locationGQL.fetch({ variables: { id } })
    return firstValueFrom(observable$)
  }
}
